import * as qs from "app/lib/helperjs";

export const DATA_FORM_EVENT_NAME = 'dataFormSubmitted';

export const FormDataHandler = () => {
    const form = document.querySelector('[data-form]');
    if (!form) {
        return;
    }

    const url = form.getAttribute('action');

    form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        const form = evt.target;
        const data = new FormData(form);

        const dataFormEvent = new CustomEvent(DATA_FORM_EVENT_NAME, {
            detail: {data, form, url}
        });

        document.dispatchEvent(dataFormEvent);
    });
};

export const preventResendingForm = (form) => {
    form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
};

export const alert = (type) => {
    const visibleClass = 'alert-visible';
    const alerts = qs.querySelectorAll('[data-form-alert]');

    if (alerts.length === 0) {
        return;
    }

    qs.removeClass(alerts, visibleClass);
    qs.addClass(
        Array.from(alerts).find((elem) => elem.getAttribute('data-form-alert') === type),
        visibleClass
    );
};